module.exports = __webpack_public_path__ + "static/img/5.b095f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colectivo-de-vida/5.png
// module id = v8D6
// module chunks = 0